import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import './style.less';

const S5 = ({ os }) => (
  <React.Fragment>
    { os === DEVICE.MOBILE
      && (
        <React.Fragment>
          <div className="light1" />
          <div className="light2" />
          <div className="light3" />
        </React.Fragment>
      )
    }
    <div className="leaf1" />
    <div className="leaf2" />
    <div className="leaf3" />
    <div className="leaf4" />
    <div className="squeral" />
    {os !== DEVICE.MOBILE && <div className="squeral2" />}
    <div className="elephant" />
    <div className="lion" />
    <div className="cabrite" />
  </React.Fragment>
);

S5.propTypes = {
  os: PropTypes.string,
};
export default S5;
